import { render, staticRenderFns } from "./expo_detail.vue?vue&type=template&id=1a960d4c&scoped=true&"
import script from "./expo_detail.vue?vue&type=script&lang=js&"
export * from "./expo_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a960d4c",
  null
  
)

export default component.exports